import React, { useState, useEffect, useRef, useContext, useCallback } from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Table } from '../../../dpe-usco'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { Button, Modal } from 'syngenta-react-components'
import TypeAhead from '../../../dpe-usco/components/TypeAhead/TypeAhead'
import { useParams } from 'react-router-dom'
import { searchUsers, postStewards, patchStewardshipHistoryData } from '../../../services/apiHelper'
import { useForm } from 'react-hook-form'
import { AuthContext } from '../../../services/context'
import { customSort } from '../../../services/utils'
import HeaderFilter from '../../../components/subComponents/HeaderFilter'

const AssignSteward = ({ status, stewards, setStewards, getStewardshipFieldsCall, isAdmin, contract_id, userInfo }) => {
  const [showModal, setShowModal] = useState(false)
  const [stopSearch, setStopSearch] = useState(false)
  const [existingUsers, setExistingUsers] = useState()
  const [selectedFromSearch, setSelectedFromSearch] = useState()
  const [isUserAlreadyAssigned, setIsUserAlreadyAssigned] = useState(false)
  const { stewardship_activity_id } = useParams()
  const { auth } = useContext(AuthContext)
  const authUserID = auth?.userInfo?.user_id

  const patchStewardshipHistoryCall = useCallback(() => {
    const userInfoForStewardship = { ...userInfo, action:'Assign Steward' }
    patchStewardshipHistoryData(contract_id, userInfoForStewardship)
  }, [
    contract_id, userInfo
  ])

  useEffect(()=>{
    setIsUserAlreadyAssigned(stewards.find(steward => steward.id === authUserID))
  }, [authUserID, stewards])

  const headerCell = (value, dataKey) => {
    const acendCallBack = () => {
      setStewards(customSort(stewards, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setStewards(customSort(stewards, dataKey, 'desc'))
    }

    return (
      <div key={value} className="cell df aic">
        <span className="pr16">{value}</span>
        <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />
      </div>
    )
  }


  const stewardStructure = {
    headers: [
      {
        value: 'Name',
        format() {
          return headerCell(this.value, 'name')
        }
      }
    ],
    dataKeys: [
      'name'
    ]
  }
  const { register, setValue, watch } = useForm({})

  const watchUserName = watch('name', '')

  const _nameCallback = val => {
    setValue('name', val.name)
    setSelectedFromSearch(val)
  }

  const saveHandler = (assignUser = false) => {
    let arg = {}
    if (assignUser) {
      arg = {
        first_name: auth.userInfo.first,
        last_name: auth.userInfo.last,
        phone: auth.userInfo.phone,
        email: auth.userInfo.email,
        stewardship_activity_id,
        external_reference_id: auth.userInfo.user_id
      }
    } else {
      arg = {
        first_name: selectedFromSearch.user_first_name || 'N/A', 
        last_name: selectedFromSearch.user_last_name || 'N/A',
        phone: selectedFromSearch.user_phone,
        email: selectedFromSearch.user_email,
        stewardship_activity_id,
        external_reference_id: selectedFromSearch.user_id
      }
    }
    postStewards(arg).then(res => {
      if (res.status === 200) {
        getStewardshipFieldsCall()
        patchStewardshipHistoryCall()
      }
    })
    setShowModal(false)
  }

  const canceled = useRef(false)
  useEffect(()=> {
    return () => {
      canceled.current = true
    }
  }, [])

  useEffect(() => {
    if (watchUserName.length > 2 && !stopSearch) {
      searchUsers(watchUserName, 'full_name' && 'email')
        .then(res => {
          if(res.length && !canceled.current){
            setExistingUsers(res)
          } 
          else if (!res.length && !canceled.current){
            searchUsers(watchUserName, 'email')
              .then(secondRes => {
                if(secondRes && !canceled.current){
                  setExistingUsers(secondRes)
                }
              })
          }
        })
      if(!canceled.current){
        setStopSearch(true)
      }
    } else {
      if (watchUserName?.length === 0) {
        setSelectedFromSearch('')
      }
    }
  }, [watchUserName, stopSearch, setSelectedFromSearch])

  useEffect(() => {
    if(!showModal) {
      setValue('name', '')
      setSelectedFromSearch('')
    }
  }, [showModal, setValue, setSelectedFromSearch])


  const renderButtons = (
    <>
      {!isUserAlreadyAssigned && <span onClick={() => saveHandler(true)} className='curp c-green'>Assign Me</span>}
      <Button type="default" text="Assign Steward" clickHandler={() => {setShowModal(true)}}/>
    </>
  )
 
  return (
    <Widget title='Stewards' button={isAdmin && renderButtons}>
      <Modal
        autoHeight
        show={showModal}
        handleClose={() => {setShowModal(false)}}
      > 
        <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
          <div className='df jcsb'>
            <p className='fz16 ml16 fw600'>Add Steward</p>
          </div>
          <div className='bt1-s-lightgray p20'>
            <TypeAhead className='fz15 lh1.4' id='name' name='name' placeholder='Search user'
              ref={register({ required: true })}
              item_id='user_id'
              item_value='name'
              item_value_additional='user_email'
              data={existingUsers}
              callback={_nameCallback}
              onChange={() => setStopSearch(false)}
            />
          </div>
          <div className='bt1-s-lightgray pb10 pt10 pr20 df jcfe'>
            <div>
              <Button customClassName="mr10" text="Cancel" clickHandler={() => {setShowModal(false)}}/>
              <Button disabled={!selectedFromSearch} type="success" text="Save" clickHandler={() => {saveHandler(false)}}/>
            </div>
          </div>
        </div>
      </Modal>
      <Table dataTestId='steward' data={stewards} structure={stewardStructure} statusComponent={status ? <TableStatus status={status}/> : null}/>
      <div className='h20'/>
    </Widget>
  )
}

export default AssignSteward